module.exports = __webpack_public_path__ + "static/media/email.a62bcb0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/email.svg
// module id = 339
// module chunks = 0